import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'app-paccsreportpopup',
  templateUrl: './paccsreportpopup.component.html',
  styleUrls: ['./paccsreportpopup.component.scss']
})
export class PaccsreportpopupComponent implements OnInit {
  routeParams: any;
  reportUrl: any;
  submitbtn: string;
  title: string;

  @Input()
  url: SafeResourceUrl;
  src: string;
  pdfSource: any;
  src1: any;
  loading = true;
  test = true;

  constructor(
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private reportService: ReportsService,
    public dialogRef: MatDialogRef<PaccsreportpopupComponent>,
    public sanitizer: DomSanitizer
  ) {
  }

  ngOnInit() {
    this.reportService.tripreport(this.data).subscribe(result => {
      if (result) {
        try {
          const decodedString = this.base64DecodeUnicode(result);
          this.src1 = this.sanitizer.bypassSecurityTrustHtml(decodedString);
          this.loading = false;
        } catch (error) {
          console.error('Error decoding content:', error);
          
        }
      }
    });
  }
  base64DecodeUnicode(base64String: string): string {
    const binaryString = atob(base64String);
    const byteNumbers = new Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      byteNumbers[i] = binaryString.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const decodedString = new TextDecoder('utf-8').decode(byteArray);
    return decodedString;
  }




  downloadpdf() {
    const pdfdata = this.data;
    pdfdata.downloadType = 1;
    this.reportService.tripreport(pdfdata).subscribe(result => {
      if (result) {
        this.pdfSource = result;
        const linkSource = 'data:application/pdf;base64, ' + result;
        const downloadLink = document.createElement('a');
        const fileName = this.data.reportType== 35 ?'Makkaludan Mudhalvar Scheme Camp Report.pdf':this.data.reportType== 36?'Farmer Grievance Details Report.pdf':this.data.reportType== 37?'Log Book Report.pdf':this.data.reportType== 38?'Booking Details and Pendency Report.pdf':this.data.reportType== 42?'Pendency Report.pdf':this.data.reportType== 43 ?'Service Providers Status Report.pdf':this.data.reportType== 51 ?'PACCS Registration Status Report.pdf':this.data.reportType== 56 ?'Scheme Progress Report.pdf':this.data.reportType== 57 ?'Mechanization Report.pdf':this.data.reportType== 68 ?'Machinery Status Report.pdf':'Paccs Report.pdf';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    });
  }

  downloadexcel() {
    const printdata = this.data;
    printdata.downloadType = 2;
    this.reportService.tripreport(printdata).subscribe(result => {
      if (result) {
        const linkSource = 'data:application/vnd.ms-excel;base64, ' + result;
        const downloadLink = document.createElement('a');
        const fileName = this.data.reportType== 35 ?'Makkaludan Mudhalvar Scheme Camp Report.xlsx':this.data.reportType== 36?'Farmer Grievance Details Report.xlsx':this.data.reportType== 37?'Log Book Report.xlsx':this.data.reportType== 38?'Booking Details and Pendency Report.xlsx':this.data.reportType== 42?'Pendency Report.xlsx':this.data.reportType== 43 ?'Service Providers Status Report.xlsx':this.data.reportType== 51 ?'PACCS Registration Status Report.xlsx':this.data.reportType== 56 ?'Scheme Progress Report.xlsx':this.data.reportType== 57 ?'Mechanization Report.xlsx':this.data.reportType== 68 ?'Machinery Status Report.xlsx':'Paccs Report.xlsx';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    });
  }

  downloadhtml() {
    const printdata = this.data;
    printdata.downloadType = 4;
    this.reportService.tripreport(printdata).subscribe(result => {
      if (result) {
        const linkSource = 'data:text/html;base64, ' + result;
        const downloadLink = document.createElement('a');
        const fileName = this.data.reportType== 35 ?'Makkaludan Mudhalvar Scheme Camp Report.html':this.data.reportType== 36?'Farmer Grievance Details Report.html':this.data.reportType== 37?'Log Book Report.html':this.data.reportType== 38?'Booking Details and Pendency Report.html':this.data.reportType== 42?'Pendency Report.html':this.data.reportType== 51 ?'PACCS Registration Status Report.html':this.data.reportType== 56 ?'Scheme Progress Report.html':this.data.reportType== 57 ?'Mechanization Report.html':this.data.reportType== 68 ?'Machinery Status Report.html':'Paccs Report.html';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    });
  }

  downloadword() {
    const worddata = this.data;
    worddata.downloadType = 3;
    this.reportService.tripreport(worddata).subscribe(result => {
      if (result) {
        const linkSource = 'data:application/msword;base64, ' + result;
        const downloadLink = document.createElement('a');
        const fileName = this.data.reportType== 35 ?'Makkaludan Mudhalvar Scheme Camp Report.doc':this.data.reportType== 36?'Farmer Grievance Details Report.doc':this.data.reportType== 37?'Log Book Report.doc':this.data.reportType== 38?'Booking Details and Pendency Report.doc':this.data.reportType== 42?'Pendency Report.doc':this.data.reportType== 51 ?'PACCS Registration Status Report.doc':this.data.reportType== 56 ?'Scheme Progress Report.doc':this.data.reportType== 57 ?'Mechanization Report.doc':this.data.reportType== 68 ?'Machinery Status Report.doc':'Paccs Report.doc';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    });
  }

  print() {
    const exceldata = this.data;
    exceldata.downloadType = 1;
    this.reportService.tripreport(exceldata).subscribe(result => {
      if (result) {
        this.printPreview(result);
      }
    });
  }

  printPreview = (data, type = 'application/pdf') => {
    let blob = null;
    blob = this.b64toBlob(data, type);
    const blobURL = URL.createObjectURL(blob);
    const theWindow = window.open(blobURL);
    const theDoc = theWindow.document;
    const theScript = document.createElement('script');
    function injectThis() {
      window.print();
    }
    theScript.innerHTML = `window.onload = ${injectThis.toString()};`;
    theDoc.body.appendChild(theScript);
  };

  b64toBlob = (content, contentType) => {
    contentType = contentType || '';
    const sliceSize = 512;
    // method which converts base64 to binary
    const byteCharacters = window.atob(content);

    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, {
      type: contentType
    }); // statement which creates the blob
    return blob;
  };

  onCancel() {
    this.dialogRef.close();
  }

  close(isProceed) {
    this.dialogRef.close(isProceed);
  }

}
